export default "__VITE_ASSET__3UHtiSCf__"